var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isInWx)?_c('van-radio-group',{staticClass:"pay-type-box",model:{value:(_vm.payType),callback:function ($$v) {_vm.payType=$$v},expression:"payType"}},[_c('van-radio',{attrs:{"name":"wx","checked-color":"#96c05f"}},[_vm._v("微信")]),_c('van-radio',{attrs:{"name":"ali","checked-color":"#009ae2"}},[_vm._v("支付宝")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }